import { request } from "../utils/request";
import { AxiosPromise } from "axios";

export const partnerApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/partner",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/partner",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/shop/partner/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/shop/partner/${id}`,
      method: "delete",
    }),
};
